import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Shapes, Ruler, ChefHat, ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ConfiguratorHighlights() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const features = [{
    icon: Shapes,
    title: "Breeder Master",
    description: "for breeders who need a polished online presence"
  }, {
    icon: Ruler,
    title: "Breeder Pro",
    description: "for breeders who want trust-building pages and stronger inquiry flow"
  }, {
    icon: ChefHat,
    title: "Breeder Authority",
    description: "for established programs ready for a premium online brand"
  }];
  return <section data-section-id="1623" id="service-details" ref={ref} className="relative w-full py-[160px] bg-background dark overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-0 w-[500px] h-[500px] bg-primary/20 rounded-full blur-[100px] -translate-x-1/2" />
        <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-secondary/10 rounded-full blur-[120px] translate-x-1/3 translate-y-1/3" />
      </div>

      <div className="container relative mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {}
          <div className={`lg:col-span-7 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
            <div className="relative group">
              {}
              <div className="absolute inset-0 bg-secondary/20 rounded-2xl transform rotate-2 scale-105 opacity-60 transition-transform duration-500 group-hover:rotate-1 group-hover:scale-100" />
              
              {}
              <div className="relative bg-secondary/5 backdrop-blur-md border border-secondary/20 shadow-2xl rounded-2xl overflow-hidden p-2 md:p-4">
                <div className="relative rounded-xl overflow-hidden bg-background/50 aspect-[4/3] md:aspect-[16/10]">
                  <img src="https://pupzstudio.10web.cloud/wp-content/uploads/2026/03/anchor_kennel_hero.webp" alt="Interface de gestion exclusive PupzStudio" className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
                  
                  {}
                  <div className="absolute top-4 right-4 flex gap-2">
                    <div className="w-8 h-8 rounded-full bg-background/80 backdrop-blur-sm shadow-sm flex items-center justify-center">
                      <div className="w-4 h-4 rounded-full bg-chart-1" />
                    </div>
                    <div className="w-8 h-8 rounded-full bg-background/80 backdrop-blur-sm shadow-sm flex items-center justify-center">
                      <div className="w-4 h-4 rounded-full bg-chart-2" />
                    </div>
                  </div>
                  
                  <div className="absolute bottom-4 left-4 right-4 bg-background/80 backdrop-blur-md rounded-lg p-3 shadow-lg border border-secondary/20">
                    <div className="flex justify-between items-center">
                      <div className="space-y-1">
                        <div className="h-2 w-24 bg-muted-foreground/20 rounded-full" />
                        <div className="h-2 w-16 bg-muted-foreground/10 rounded-full" />
                      </div>
                      <div className="h-8 w-20 bg-secondary/10 rounded-md" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {}
          <div className={`lg:col-span-5 space-y-10 transition-all duration-1000 delay-300 ease-out ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="space-y-6">
              <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-medium text-foreground leading-tight">Simple packages for breeders at every stage</h2>
              <p className="text-lg text-muted-foreground leading-relaxed font-sans tracking-wide">Showcase what makes your program... you!</p>
            </div>

            <ul className="space-y-6">
              {features.map((feature, i) => <li key={i} data-index={i} className="group flex items-start gap-4 p-4 rounded-xl hover:bg-secondary/10 transition-colors duration-300">
                  <div className="mt-1 p-2 rounded-full bg-card shadow-sm border border-border/50 group-hover:border-secondary/30 transition-colors">
                    <feature.icon className="w-6 h-6 text-secondary transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1} />
                  </div>
                  <div>
                    <h3 className="font-serif text-xl font-semibold text-foreground mb-1">
                      {feature.title}
                    </h3>
                    <p className="text-sm text-muted-foreground font-sans tracking-normal">
                      {feature.description}
                    </p>
                  </div>
                </li>)}
            </ul>

            <div className="pt-4">
              <Button asChild variant="default" size="lg" className="group px-8 py-6 text-sm font-bold uppercase tracking-widest h-auto rounded-xl transition-all duration-300 shadow-lg shadow-primary/20">
                <Link to="/Pricing">View Pricing</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}